import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String, text: String }

  get shareUrl() {
    return this.urlValue || window.location.origin + "/preventes"
  }

  get shareText() {
    return this.textValue || "Je viens de précommander mon Calendrier de l'Avent littéraire sur La Kube\u00a0! 📚🎄"
  }

  twitter() {
    const params = new URLSearchParams({ text: this.shareText, url: this.shareUrl })
    window.open(`https://x.com/intent/tweet?${params}`, "_blank", "noopener,width=550,height=420")
  }

  facebook() {
    const params = new URLSearchParams({ u: this.shareUrl })
    window.open(`https://www.facebook.com/sharer/sharer.php?${params}`, "_blank", "noopener,width=550,height=420")
  }

  whatsapp() {
    const message = `${this.shareText} ${this.shareUrl}`
    window.open(`https://wa.me/?text=${encodeURIComponent(message)}`, "_blank", "noopener")
  }

  async copy() {
    const button = event.currentTarget
    const originalText = button.textContent

    try {
      await navigator.clipboard.writeText(this.shareUrl)
      button.textContent = "✅ Lien copié\u00a0!"
      setTimeout(() => { button.textContent = originalText }, 2000)
    } catch {
      // Fallback for older browsers
      const input = document.createElement("input")
      input.value = this.shareUrl
      document.body.appendChild(input)
      input.select()
      document.execCommand("copy")
      document.body.removeChild(input)
      button.textContent = "✅ Lien copié\u00a0!"
      setTimeout(() => { button.textContent = originalText }, 2000)
    }
  }
}
